// initilaize Language, FullSrc and Domain name
var lang = document.documentElement.lang
var fullsrc = $(location).attr('href')
var domain = $(location).attr('hostname')
// --------------------------------------------------------------------------------
// Rtl Scripts Important
var _rtl = false

// Validation Rules
var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/
var numReg = /[0-9]/
// ------------------------------------------------------------------

jQuery(document).ready(function ($) {
  'use strict'
  rtlDetection()

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  })

  $('.NumericOnly').keydown(function (event) {
    // Allow: backspace, delete, tab, escape, and enter
    if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 ||
      event.keyCode === 27 || event.keyCode === 13 ||
      // Allow: Ctrl+A
      (event.keyCode === 65 && event.ctrlKey === true) ||
      // Allow: home, end, left, right
      (event.keyCode >= 35 && event.keyCode <= 39)) {
      // let it happen, don't do anything
      return ''
    }
    else {
      // Ensure that it is a number and stop the keypress
      if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) &&
        (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault()
      }
    }
  })

  // --------------------------------------------------------------------------------

  function stripHTML (dirtyString) {
    var container = document.createElement('div')
    var text = document.createTextNode(dirtyString)
    container.appendChild(text)
    return container.innerHTML // innerHTML will be a xss safe string
  }

  function isNumberKey (evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  function rtlDetection () {
    if ($('body').css('direction') === 'rtl') {
      _rtl = true
    }
  }
})